import React, { useEffect, useRef } from "react";
import { counterUp } from "./counterUp";
function Counter({
  counterSettings
}) {
  const targetRef = useRef(null);
  const counterValueSettings = counterSettings?.counterValue;
  const counterLabelSettings = counterSettings?.counterLabel;
  const counterSpeed = counterSettings?.animationSpeed;
  const counterRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Start the counter animation when the target is visible
          if (counterRef.current) {
            const duration = 2000 - counterSpeed * 12;
            counterUp(counterRef.current, {
              duration: counterSpeed === 0 ? 0 : duration
            });
          }
          // Unobserve the target once animation is started
          observer.unobserve(entry.target);
        }
      });
    });
    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    // Clean up the observer
    return () => {
      observer.disconnect();
    };
  }, [counterSpeed]);
  const smallScale = 0.9;
  const mediumScale = 0.85;
  const smallestScreen = 375;
  const largestScreen = 1440;
  const range = largestScreen - smallestScreen;
  const valueFontSize = counterValueSettings?.size || 48;
  const labelFontSize = counterLabelSettings.size || 16;
  const minValueFontSize = valueFontSize * mediumScale;
  const minLabelFontSize = labelFontSize * smallScale;
  const valueFontSizeCalc = `clamp(${minValueFontSize}px, calc(${minValueFontSize}px + (${valueFontSize} - ${minValueFontSize}) * ((100vw - ${smallestScreen}px) / (${range}))), ${valueFontSize}px)`;
  const labelFontSizeCalc = `clamp(${minLabelFontSize}px, calc(${minLabelFontSize}px + (${labelFontSize} - ${minLabelFontSize}) * ((100vw - ${smallestScreen}px) / (${range}))), ${labelFontSize}px)`;
  return /*#__PURE__*/React.createElement("div", {
    ref: targetRef,
    id: "general-text"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      "--counter-value-font-size": valueFontSizeCalc,
      fontSize: `var(--counter-value-font-size)`,
      lineHeight: "normal",
      color: counterValueSettings?.color?.value
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: counterRef,
    "data-counter": "counterup"
  }, counterValueSettings.value || "0")), counterSettings?.LabelEnabled && /*#__PURE__*/React.createElement("div", {
    style: {
      "--counter-label-font-size": labelFontSizeCalc,
      fontSize: `var(--counter-label-font-size)`,
      lineHeight: "normal",
      color: counterLabelSettings.color?.value
    }
  }, counterLabelSettings.value));
}
export default Counter;
//# sourceMappingURL=Counter.js.map